<script lang="ts">
	import { navigate } from "svelte-navigator";

	import { create_grocery_list } from "../tastummy";

	import {
		exclude_list,
		flattened_all_groceries,
		flattened_groceries,
	} from "./recipe_stores";
	let checked: Set<string> = new Set();
	$: aisles = Array.from($flattened_groceries.keys());
	function update(
		event: Event & { currentTarget: EventTarget & HTMLInputElement },
		item: string
	) {
		if (event.currentTarget.checked) {
			checked.add(item);
		} else {
			checked.delete(item);
		}
	}
	function clear_items() {
		for (var i of checked) {
			$exclude_list.add(i);
			$exclude_list = $exclude_list;
		}
		checked = new Set();
	}

	function save_list() {
		let local_groceries = [];
		for (var aisle of aisles) {
			for (var item of $flattened_all_groceries.get(aisle)) {
				item["aisle"] = aisle;
				if ($exclude_list.has(`${item.name}_${item.unit}`)) {
					item["cleared"] = true;
				} else {
					item["cleared"] = false;
				}
				if (checked.has(`${item.name}_${item.unit}`)) {
					item["checked"] = true;
				} else {
					item["checked"] = false;
				}
				// id generated on backend so we remove it here
				delete item["id"];
				local_groceries.push(item);
			}
		}
		create_grocery_list(local_groceries)
			.then((r) => {
				navigate("/grocery-list/" + r.data.id);
			})
			.catch(() => console.log("Error creating grocery list"));
	}
</script>

{#each aisles as aisle}
	<h1>{aisle}</h1>
	{#each $flattened_groceries.get(aisle) as ing (`${ing.name}_${ing.amount}_${ing.unit}_${ing.id}`)}
		<div class="recipe-text">
			<input
				type="checkbox"
				on:change={(e) => update(e, `${ing.name}_${ing.unit}`)}
			/>
			<p>{ing.name} - {ing.amount} {ing.unit}</p>
		</div>
	{/each}
{/each}
<br />
<button on:click={clear_items}>Clear Checked</button>
<button on:click={save_list}>Save List</button>

<style>
	p {
		display: inline-block;
	}
	.recipe-text {
		padding: 15px;
		display: inline-block;
	}
</style>
